import { useAuth0User } from './useAuth0User';
import { isSupplier } from 'utils/helpers/permissions.helpers';

export const useHasSuppliersPermission = () => {
  const auth0User = useAuth0User();
  const hasSuppliersPermission = !isSupplier(auth0User); // suppliers can't view other suppliers

  return {
    isLoading: auth0User.isLoading,
    data: hasSuppliersPermission,
  };
};
